import React from "react";
import "./LoadingMessage.css";

export const LoadingMessage = () => {
  return (
    <div className="loading-message-container">
      <img src="/imgs/reino_player_title.svg" alt="Loading" className="loading-image" />
      <p className="loading-text">Carregando...</p>
      <div className="loading-spinner"></div>
    </div>
  );
};
